<template>
	<div class="send-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_send_page_v2.sec_01.title.one') }}
					<br />
					{{ $t('new_ui.personal_send_page_v2.sec_01.title.two') }}
					<strong>
						{{ $t('new_ui.personal_send_page_v2.sec_01.title.three') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.personal_send_page_v2.sec_01.desc.one') }}<br />
					{{ $t('new_ui.personal_send_page_v2.sec_01.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_send_page_v2.sec_01.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_send_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-04">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.personal_send_page_v2.sec_04.title') }}
				</h3>
				<div class="card-box">
					<div class="card-content card-content-01">
						<div class="txt">
							<h5>
								{{ $t('new_ui.personal_send_page_v2.sec_04.cards.one.title') }}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.one.description.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.one.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconSend01" alt="" />
					</div>
					<div class="card-content card-content-02">
						<div class="txt">
							<h5>
								{{ $t('new_ui.personal_send_page_v2.sec_04.cards.two.title') }}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.two.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.two.description.two',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.two.description.three',
									)
								}}
							</p>
						</div>
						<img :src="img.iconSend02" alt="" />
					</div>
					<div class="card-content card-content-03">
						<div class="txt">
							<h5>
								{{
									$t('new_ui.personal_send_page_v2.sec_04.cards.three.title')
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.three.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.three.description.two',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_send_page_v2.sec_04.cards.three.description.three',
									)
								}}
							</p>
						</div>
						<img :src="img.iconSend03" alt="" />
					</div>
				</div>
			</div>
		</section>

		<section class="sec-03">
			<div class="container-box">
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.personal_send_page_v2.sec_03.one.title.one')
							}}<br />
							{{ $t('new_ui.personal_send_page_v2.sec_03.one.title.two') }}
						</h3>
						<p>
							{{ $t('new_ui.personal_send_page_v2.sec_03.one.desc.one')
							}}<br />{{
								$t('new_ui.personal_send_page_v2.sec_03.one.desc.two')
							}}
						</p>
					</div>
					<div class="img-box">
						<img :src="img.imgSendSec0301" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgSendSec0302" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.personal_send_page_v2.sec_03.two.title.one') }}
						</h3>
						<p>
							{{ $t('new_ui.personal_send_page_v2.sec_03.two.desc.one') }}
							<br />
							{{ $t('new_ui.personal_send_page_v2.sec_03.two.desc.two') }}
							<br /><br />
							{{ $t('new_ui.personal_send_page_v2.sec_03.two.desc.three') }}
						</p>
					</div>
				</div>
			</div>
		</section>
		<section class="sec-09">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_send_page_v2.sec_09.title.one') }}<br />
					{{ $t('new_ui.personal_send_page_v2.sec_09.title.two') }}
				</h3>
				<p>
					{{ $t('new_ui.personal_send_page_v2.sec_09.one.desc.one') }}<br />
					{{ $t('new_ui.personal_send_page_v2.sec_09.one.desc.two') }}
				</p>
			</div>
		</section>
	</div>
</template>

<script>
import imgSendSec0301 from '@/assets/images/v2/img-send-sec-03-01.png';
import imgSendSec0302 from '@/assets/images/v2/img-send-sec-03-02.png';
import iconSend01 from '@/assets/images/v2/icon/icon-send-01.svg';
import iconSend02 from '@/assets/images/v2/icon/icon-send-02.svg';
import iconSend03 from '@/assets/images/v2/icon/icon-send-03.svg';

export default {
	data: () => {
		return {
			img: {
				imgSendSec0301,
				imgSendSec0302,
				iconSend01,
				iconSend02,
				iconSend03,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
